"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressProvider = exports.useAddressState = exports.useAddressDispatch = exports.reducer = void 0;

var _tslib = require("tslib");

var _react = _interopRequireWildcard(require("react"));

var _AddressContext = require("./AddressContext");

var _utility = require("../utility");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var reducer = function reducer(state, _a) {
  var type = _a.type,
      payload = _a.payload;

  switch (type) {
    case "SET"
    /* SET */
    :
      return (0, _tslib.__assign)((0, _tslib.__assign)({}, state), payload);

    case "UNSET"
    /* UNSET */
    :
      return _AddressContext.initialState;

    default:
      throw new Error("Unsupported action type " + type);
  }
};

exports.reducer = reducer;

var AddressProvider = function AddressProvider(_a) {
  var children = _a.children;

  var _b = (0, _react.useReducer)(reducer, (0, _utility.getAddressState)("@lce/local/address"
  /* Address */
  ) || _AddressContext.initialState),
      state = _b[0],
      dispatch = _b[1];

  (0, _react.useEffect)(function () {
    (0, _utility.setAddressState)("@lce/local/address"
    /* Address */
    , state);
  }, [state]);
  return _react["default"].createElement(_AddressContext.AddressStateContext.Provider, {
    value: state
  }, _react["default"].createElement(_AddressContext.AddressDispatchContext.Provider, {
    value: dispatch
  }, children));
};

exports.AddressProvider = AddressProvider;

var useAddressState = function useAddressState() {
  var context = (0, _react.useContext)(_AddressContext.AddressStateContext);

  if (context === undefined) {
    throw new Error('useAddressState must be used within AddressProvider');
  }

  return context;
};

exports.useAddressState = useAddressState;

var useAddressDispatch = function useAddressDispatch() {
  var context = (0, _react.useContext)(_AddressContext.AddressDispatchContext);

  if (context === undefined) {
    throw new Error('useAddressDispatch must be used within AddressProvider');
  }

  return context;
};

exports.useAddressDispatch = useAddressDispatch;